module.exports = __webpack_public_path__ + "img/filter-welcome-background-chevy.d665e099.png";